import React from 'react';
import {Link} from 'react-router-dom';

const ProviderWorkshopsInfo = ({provider})=>{

  return(
    <div className="provider-workshops purchased col-12 col-md-3">
        <h4 className="title">Workshops provided</h4>
        <ul className="workshops">
          {provider.provided_workshops.map(el=>
            <li className="workshop" key={`workshop${el.id}`}>
              {
                el.workshop_type == 'in_person' ?
                  <Link to={`/admin/regular/${el.id}`}>{el.title}</Link> :
                el.workshop_type == 'online' ?
                    <Link to={`/provider/my_workshop/${el.id}`}>{el.title}</Link> :
                <span class="no-url" style={{color: "gray"}}>{el.title}</span>
              }

            </li>)
          }
        </ul>
    </div>
  )
}

export default ProviderWorkshopsInfo



// WEBPACK FOOTER //
// ./src/components/provider/ProviderWorkshopsInfo.jsx